import React from 'react';
import Loader from "react-loader-spinner";
import { Button, ButtonToolbar, ToggleButton, ToggleButtonGroup } from "react-bootstrap";
import { Navbar } from "react-bootstrap";
import ImageViewer from '../../Common/ImageViewer/ImageViewer';
import externalService from '../../../Services/ExternalService';
import { connect } from 'react-redux';
import './ViewJobAttachments.scss';

class ViewJobAttachments extends React.Component {

    state = {
        jobId: this.props.jobId,
        isLoading: false,
        attachments: []
    }

    constructor(props) {
        super(props);
    }
    componentDidMount() {
        const { jobId } = this.props;
        this.getAttachments(jobId);
    }

    getAttachments = (jobId) => {
        this.setState({ isLoading: true });
        externalService.getAttachmentsByJobId(jobId).then(res => {
                
                let imageArray = [];
               
                    for (var i = 0; i < res.length; i++) {
                       
                            let image = res[i];
                            imageArray.push(image);
                    
                }

                this.setState({
                    attachments: imageArray,
                    isLoading: false
                });
            
        });
    }
    render() {

        const { isLoading, attachments } = this.state;
        return (
            <div className="App">
                <div className="home-wrapper container">
                    <Navbar  className="top-nav-bar p-0"  expand="xl">
                    <div className='col-12 col-md-6 d-flex justify-content-center justify-content-md-start px-0'>
                        <a className="navbar-brand" href="#"><img src="/images/app-logo.svg" alt="Bricks + Agent" className="logo" /></a> 
                    </div>
                    <div className='col-12 col-md-6 d-flex justify-content-center justify-content-md-start px-0 mt-2 mt-md-0'>
                        <h3 className="align-items-center my-0">Attachments</h3> 
                    </div>
                    </Navbar>
                    <div className="row attachments-card">
                        {isLoading ? <h2 className="align-items-center d-block">
                            <Loader type="ThreeDots" color={"#DB3D44"} height={10} width={100} />
                        </h2> :
                            
                            <div style={{ lineHeight: "25px", width: "100%" }}>
 
                                <div className="innerHtmlContainer">
                                   
                                    {attachments && attachments.length>0?
                                    <div>
                                        <h6>Job Attachment(s)</h6>
                                        <div className="attach-body">
                                            <ImageViewer
                                                attachments={attachments}
                                                isAfter={false}
                                                isExternal={true}
                                            ></ImageViewer>
                                        </div>
                                    </div>:<div>
                                    <h6>Attachment(s) Not Found</h6>
                                        </div>
                                    }
                                </div>

                            </div>}
                    </div>
                </div>
            </div>
        )
    }

}

export default connect()( ViewJobAttachments );